export enum Access {
  ADMIN = 'Admin',
  USER = 'Usuário',
}
